if (!customElements.get('glossary-index')) {
  customElements.define(
    'glossary-index',
    class GlossaryIndex extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-glossary-nav]');
        this.alphaList = this.querySelector('.glossary-index__alpha-list');
        this.letterLinks = this.querySelectorAll('[data-glossary-letter]');
        this.filterBtns = this.querySelectorAll('[data-glossary-filter]');
        this.termCards = this.querySelectorAll('[data-glossary-term]');
        this.letterGroups = this.querySelectorAll('[data-glossary-group]');
        this.noResults = this.querySelector('[data-glossary-no-results]');
        this.visibleCount = this.querySelector('[data-glossary-visible-count]');
        this.activeCategory = 'all';

        this.initSmoothScroll();
        this.initStickyNav();
        this.initActiveLetterHighlight();
        this.initCategoryFiltering();
      }

      initSmoothScroll() {
        const nav = this.nav;
        this.letterLinks.forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);
            if (target && !target.hidden) {
              const navHeight = nav.offsetHeight;
              const y = target.getBoundingClientRect().top + window.pageYOffset - navHeight - 16;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          });
        });
      }

      initStickyNav() {
        if (!this.nav) return;
        const nav = this.nav;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              nav.classList.toggle('is-stuck', !entry.isIntersecting);
            });
          },
          { threshold: 1, rootMargin: '-1px 0px 0px 0px' }
        );
        observer.observe(nav);
      }

      scrollNavToActive(activeLink) {
        if (!this.alphaList || !activeLink) return;
        const listRect = this.alphaList.getBoundingClientRect();
        const linkRect = activeLink.getBoundingClientRect();
        const scrollLeft = this.alphaList.scrollLeft + linkRect.left - listRect.left - (listRect.width / 2) + (linkRect.width / 2);
        this.alphaList.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }

      initActiveLetterHighlight() {
        if (this.letterGroups.length === 0) return;
        const letterLinks = this.letterLinks;
        const self = this;
        const groupObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const letter = entry.target.getAttribute('data-glossary-group');
                letterLinks.forEach((link) => {
                  const isActive = link.getAttribute('data-glossary-letter') === letter;
                  link.classList.toggle('is-active', isActive);
                  if (isActive) self.scrollNavToActive(link);
                });
              }
            });
          },
          { rootMargin: '-80px 0px -70% 0px' }
        );
        this.letterGroups.forEach((group) => groupObserver.observe(group));
      }

      initCategoryFiltering() {
        this.filterBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.activeCategory = btn.getAttribute('data-glossary-filter');

            this.filterBtns.forEach((b) => {
              b.classList.remove('is-active');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');

            let visibleTerms = 0;

            this.termCards.forEach((card) => {
              const matches = this.activeCategory === 'all' || card.getAttribute('data-category') === this.activeCategory;
              card.hidden = !matches;
              if (matches) visibleTerms++;
            });

            this.letterGroups.forEach((group) => {
              const hasVisible = group.querySelectorAll('[data-glossary-term]:not([hidden])').length > 0;
              group.hidden = !hasVisible;
            });

            this.letterLinks.forEach((link) => {
              const letter = link.getAttribute('data-glossary-letter');
              const group = document.getElementById('glossary-' + letter);
              if (group) {
                link.classList.toggle('is-disabled', group.hidden);
              }
            });

            if (this.noResults) {
              this.noResults.classList.toggle('is-visible', visibleTerms === 0);
            }

            if (this.visibleCount) {
              this.visibleCount.textContent = visibleTerms;
            }
          });
        });
      }
    }
  );
}
